import React from "react";

export default function Pinterest({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="39.725"
      height="40.627"
      viewBox="0 0 39.725 40.627"
      className={className}
    >
      <path
        id="Path_301"
        data-name="Path 301"
        d="M1155.872,8218a20.032,20.032,0,0,1,19.854,20.169c.018,11.35-8.848,20.476-19.863,20.458a20.318,20.318,0,0,1,.009-40.627Z"
        transform="translate(-1136 -8218)"
        fill="currentColor"
      />
      <path
        id="Path_558"
        data-name="Path 558"
        d="M11.99,0C5.468,0,2,4.179,2,8.737c0,2.113,1.181,4.749,3.071,5.585.287.129.443.074.507-.192.057-.2.3-1.176.425-1.636a.421.421,0,0,0-.1-.413A5.419,5.419,0,0,1,4.777,8.792c0-3.178,2.527-6.265,6.827-6.265,3.718,0,6.32,2.415,6.32,5.87,0,3.9-2.066,6.605-4.751,6.605a2.127,2.127,0,0,1-2.241-2.609c.424-1.718,1.255-3.565,1.255-4.8a1.845,1.845,0,0,0-1.91-2.03c-1.513,0-2.74,1.5-2.74,3.509a5,5,0,0,0,.452,2.14L6.215,18.382a16.051,16.051,0,0,0,.11,5.273.157.157,0,0,0,.286.073,18.739,18.739,0,0,0,2.463-4.639c.184-.68.941-3.436.941-3.436a4.112,4.112,0,0,0,3.468,1.654c4.557,0,7.85-4.005,7.85-8.976C21.317,3.565,17.239,0,11.99,0"
        transform="translate(8.487 9.259)"
        fill="#f6f5f1"
      />
    </svg>
  );
}
